import BaseApi from "./BaseApi";
import { ApiPaths } from './ApiPaths';

const create = () => {
    
    const api = BaseApi.create({ errorCodes: [400, 403]});

    const getDistrictOfficesList = (sort, reversed, limit, offset, districtIdFilter) => api.get(ApiPaths.GET_DISTRICT_OFFICES(sort, reversed, offset, limit, districtIdFilter));
    const getDistricts = () => api.get(ApiPaths.DISTRICTS);
    
    return {
        getDistrictOfficesList,
        getDistricts
    };
};

// let's return back our create method as the default.
export default {
    create
};